export function modal_idinit() {
    var modalbtn = document.querySelectorAll(".modalbtn")
    var close_btn = document.querySelectorAll(".Modalcnt__close");
    var close_bg = document.querySelectorAll(".Modalcnt");

    //それぞれのクラスにイベントをつける
    Array.prototype.forEach.call(modalbtn, function (target) {
        target.addEventListener("click", function () {
            var modal = document.getElementById(target.dataset.modal)
            toggleClass(modal);
        });
    });

    Array.prototype.forEach.call(close_btn, function (target) {
        target.addEventListener("click", function () {
            var close = target.parentNode.parentNode;
            toggleClass(close);
        });
    });

    Array.prototype.forEach.call(close_bg, function (target) {
        target.addEventListener("click", function (e) {
            if (e.target != e.currentTarget)
                return; //子要素がクリックされたら無視
            var close = target;
            toggleClass(close);
        });
    });

    function toggleClass(klass) {
        klass.classList.toggle("is-on");

        //modal出てるときはスクロールさせない
        if (klass.classList.contains("is-on")) {
            document.documentElement.style.overflowY = "hidden";
            document.documentElement.style.overflowY = "hidden";
        } else {
            document.documentElement.style.overflowY = "auto";
            document.documentElement.style.overflowY = "auto";
        }
    }
}

export function modal_idreset() {
    document.documentElement.style.overflowY = "auto";
    document.documentElement.style.overflowY = "auto";
}